import { makeStyles } from "tss-react/mui";
import { Theme } from "@mui/material";

interface IParams {
    getColor?(theme: Theme): string;
}

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    iconBox: {
        display: "inline-flex",
        alignItems: "center",
        "& svg": {
            width: "0.75em",
            height: "0.75em",
        },
        "& g": {
            fill: props.getColor?.(theme) ?? theme.palette.primary.main,
        },
        "& path": {
            fill: props.getColor?.(theme) ?? theme.palette.primary.main,
        },
    },
}));
